import type { ReactNode } from 'react';
import { useEffect } from 'react';

export type TamanhoModal = 'sm' | 'md' | 'lg';

type Props = {
  aberto: boolean;
  titulo: string;
  onFechar: () => void;
  children: ReactNode;
  rodape?: ReactNode;
  tamanho?: TamanhoModal;
};

export function Modal({ aberto, titulo, onFechar, children, rodape, tamanho = 'sm' }: Props) {
  useEffect(() => {
    if (!aberto) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onFechar();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [aberto, onFechar]);

  if (!aberto) return null;

  return (
    <div className="modal__backdrop" role="dialog" aria-modal="true" aria-label={titulo}>
      <div className={`modal__panel modal__panel--${tamanho}`}>
        <header className="modal__header">
          <h3>{titulo}</h3>
          <button
            className="btn btn--ghost"
            onClick={onFechar}
            aria-label="Fechar"
            data-tooltip-id="icon-tip"
          >
            ×
          </button>
        </header>
        <div className="modal__body">{children}</div>
        {rodape && <footer className="modal__footer">{rodape}</footer>}
      </div>
    </div>
  );
}
